import { useParams, Link } from "react-router-dom";
import { useSettings } from "../lib/settings";

const DEFAULTS = {
  privacy: { title: "Privacy Policy", field: "privacy_body" },
  terms: { title: "Terms of Service", field: "terms_body" },
  faq: { title: "FAQ", field: "faq_body" },
  shipping: { title: "Shipping & Returns", field: "shipping_body" },
  about: { title: "Our Story", field: "about_body" },
  contact: { title: "Contact", field: null },
};

export default function Info() {
  const { slug } = useParams();
  const { settings } = useSettings();
  const c = DEFAULTS[slug];
  if (!c) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-24 text-center">
        <h1 className="font-serif text-4xl">Page not found</h1>
        <Link to="/" className="mt-4 inline-block text-[var(--accent)]">← Home</Link>
      </div>
    );
  }
  // Override about title from settings
  const title = slug === "about" && settings.about_title ? settings.about_title : c.title;
  const body = c.field
    ? settings[c.field] || ""
    : `For collaborations, press, wholesale or just to say hi — drop a note at ${settings.contact_email || "hello@thisthatforme.shop"}.`;
  // Split body by blank lines into sections
  const sections = body.split(/\n\s*\n/).filter((s) => s.trim());

  return (
    <div data-testid={`info-${slug}`} className="max-w-3xl mx-auto px-4 py-20">
      <div className="text-center">
        <div className="uppercase text-xs tracking-[0.4em] text-[#5C5547]">Information</div>
        <h1 className="mt-3 font-serif text-4xl sm:text-5xl gold-heading">{title}</h1>
        <div className="mt-6 mx-auto h-px w-24 gold-line" />
      </div>
      <div className="mt-12 space-y-8">
        {sections.map((para, i) => (
          <article
            key={`${slug}-${i}-${para.length}`}
            className="p-7 rounded-2xl bg-[#FDFBF7]"
            style={{ border: "3px solid var(--accent)" }}
          >
            <p className="text-[#5C5547] leading-relaxed whitespace-pre-line">{para}</p>
          </article>
        ))}
      </div>
    </div>
  );
}
